import { configureSentry } from "./helpers/functions";

configureSentry({
    dsn: "https://f33db9523f1f4a9a8a4ba78a6ee47bf5@sentry.4-com.pro/48",
});

